import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import '../styles/theme.scss';

import '@/lib/select.js';
import app from '@/app.js';
import router from '@/router.js';
import { fetchCart, addItemById } from '@/lib/cart.js';
import { getElementHeight } from './utils';
import { refreshMenuState } from '@/components/menu';


const mqMobile = window.matchMedia('(max-width: 768px)');
const mqDesktop = window.matchMedia('(min-width: 1200px)');

const addBasketEventListeners = () => {
  const buttons = document.querySelectorAll('.js-add-to-basket');
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      addItemById(this.dataset.productId);
    });
  });
};

mqMobile.addEventListener('change', storeHeaderHeight);
mqDesktop.addEventListener('change', storeHeaderHeight);

window.addEventListener('popstate', () => {
  setTimeout(() => {
    window.scrollTo({
      left: 0,
      top: router.state.scroll.y,
      behavior: 'smooth',
    });
  }, 800);
});



router.on('after', () => {
  app.unmount();
  app.mount();
  addBasketEventListeners();
  refreshMenuState();

  window.scrollTo(0, 0);
});

Promise.all([
  fetchCart()
]).then(([cart]) => {
  app.hydrate({ cart });
  app.mount();
  storeHeaderHeight();
  window.scrollTo(0, 0);
});

const storeHeaderHeight = () => {
  const headerHeight = getElementHeight('.js-header');
  const announcementBarHeight = getElementHeight('.js-announcement-bar');
  const combinedHeight = headerHeight + announcementBarHeight;

  const current = document.documentElement.style.getPropertyValue('--header-height');
  if (combinedHeight !== current) {
    document.body.style = `--header-height: ${combinedHeight}px;`;
    app.emit('header:update', { 'headerHeight': combinedHeight });
  }
};